import { NavLink } from "react-router-dom";
import { cn } from "../client/cn";
import { useEffect } from "react";
import { useAuth } from "wasp/client/auth";
import {
  useQuery,
  createPortal,
  getOrCreateCustomer,
  getCustomer,
} from "wasp/client/operations";

type MenuItemProps = {
  click?: any;
  icon?: React.ReactNode;
  href?: string;
  dataCbType?: string;
  className?: string;
} & React.PropsWithChildren;

const MenuItem = ({
  click,
  icon,
  children,
  href,
  dataCbType,
  className,
}: MenuItemProps) => {
  const { data: user, isLoading } = useAuth();

  const {
    data: portal,
    isLoading: isLoadingPortal,
    error: portalError,
  } = useQuery(createPortal, { customerEmail: user!.email });

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.chargebee.com/v2/chargebee.js";
    script.setAttribute("data-cb-site", "marketplaceiq");
    script.async = true;
    script.onload = () => {
      //console.log("Chargebee script loaded successfully");
      (window as any).Chargebee.init({
        site: "marketplaceiq",
      });
    };
    script.onerror = (error) => {
      console.error("Error loading Chargebee script", error);
    };
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const openPortalWithScript = () => {
    if ((window as any).Chargebee) {
      const cbInstance = (window as any).Chargebee.getInstance();
      cbInstance.setPortalSession((portal as any).portal_session.token);
      var chargebeePortalInstance = cbInstance.createChargebeePortal();
      chargebeePortalInstance.open();
    }
  };

  const handleUpgrade = async () => {
    try {
      window.location.href = "/auth/redirect";
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div onClick={handleUpgrade} className={className}>
      {icon && <span className="text-gray-600 dark:text-white">{icon}</span>}
      {children}
    </div>
  );
};

export default MenuItem;
